goog.provide("shadow.js.shim.module$date_fns$isAfter$default");
shadow.js.shim.module$date_fns$isAfter$default = shadow.js.require(126, {})["default"];
